import Image from "next/image";

import Heading from "../heading";

import styles from "./how-to-get-started.module.scss";

export default function HowToGetStarted({ steps = [], className = "" }) {
  return (
    <div className={`container lg:mb-44 ${className}`}>
      <div className="ml-4 md:ml-0">
        <Heading small> How to Get Started</Heading>
      </div>

      <div className={styles.Steps}>
        {steps.map((step) => (
          <div className={styles.Step} key={step.title}>
            <div className={styles.Image}>
              <Image
                src={`${step.image.url}?w=331&fm=webp&q=80`}
                width="331"
                height="227"
                layout="responsive"
                alt={step.title}
                objectFit="cover"
              />
            </div>

            <div className={styles.StepContent}>
              <h5>{step.title}</h5>

              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
